export default __webpack_public_path__ + "static/874-d72ce718a121f9990115dae8c828f8d3.gif";